module.exports = __webpack_public_path__ + "static/media/sc10.806ccae1.jpg";